/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { StatusIconMap, useTheme, InputContainer } from '../utils/index.js';
/**
 * Group Checkbox/Radio components together
 * @example
 * <caption>Group checkboxes</caption>
 * <InputGroup label='Checkbox group'>
 *  <Checkbox />
 *  <Checkbox />
 * </InputGroup>
 * @example
 * <caption>Group radios</caption>
 * <InputGroup label='Radio group'>
 *  <Radio />
 *  <Radio />
 * </InputGroup>
 */
export const InputGroup = (props) => {
    const { children, disabled = false, displayStyle = 'default', label, message, status, svgIcon, className, style, required = false, ...rest } = props;
    useTheme();
    const icon = () => {
        if (svgIcon) {
            return React.cloneElement(svgIcon, { 'aria-hidden': true });
        }
        if (status && message) {
            return React.cloneElement(StatusIconMap[status](), {
                'aria-hidden': true,
            });
        }
        return undefined;
    };
    return (React.createElement(InputContainer, { label: label, disabled: disabled, required: required, status: status, message: message, icon: icon(), isLabelInline: displayStyle === 'inline', className: className, style: style, ...rest },
        React.createElement("div", { className: 'iui-input-group' }, children)));
};
export default InputGroup;
